import request from '@/utils/request'


//查詢
export function GetUserAwbQueryList(data) {
    return request({
        url: '/UserAwbQuery/GetUserAwbQueryList',
        method: 'post',
        data: data,
        enableLoading:false,
        iserror:true
    })
}